import 'summernote/dist/summernote-bs4.min.js'
export default function() {

  // Summernote text editor
  if ($('.summernote-default').length !== 0) {
    $('.summernote-default').summernote({
      minHeight: 150,
      dialogsInBody: true,
      toolbar: [
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link']],
      ]}
    );
  }

  // Limited version
  if ($('.summernote-limited').length !== 0) {
    $('.summernote-limited').summernote({
      minHeight: 150,
      dialogsInBody: true,
      toolbar: [
        ['font', ['bold', 'italic', 'clear']],
        ['insert', ['link']],
      ]}
    );
  }

  // PDF version - formatting available for html or PDF
  if ($('.summernote-report').length !== 0) {
    $('.summernote-report').summernote({
      minHeight: 150,
      dialogsInBody: true,
      toolbar: [
        ['font', ['bold', 'italic', 'underline', 'superscript']],
        ['view', ['codeview']]
      ]}
    );
  }

  // Expanded version
  if ($('.summernote-expanded').length !== 0) {
    $('.summernote-expanded').summernote({
      minHeight: 150,
      dialogsInBody: true,
      toolbar: [
        ['font', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link', 'video', 'picture']],
        ['view', ['fullscreen', 'codeview']]
     ]}
    );
  }


}